/**
 * 品牌配置 — 通过 NEXT_PUBLIC_* 环境变量控制
 * 所有默认值保持 FF 品牌，确保向后兼容
 *
 * Aixc 部署时只需在 .env 中覆盖对应变量即可切换品牌
 */
export const brand = {
  appTitle: process.env.NEXT_PUBLIC_APP_TITLE || 'FF AI Workspace',
  brandName: process.env.NEXT_PUBLIC_BRAND_NAME || 'FF AI Workspace',
  shortName: process.env.NEXT_PUBLIC_APP_SHORT_NAME || 'FF AI WS',
  slogan: process.env.NEXT_PUBLIC_BRAND_SLOGAN || 'FIGHT TO THE FIRST!',
  taglineEn: process.env.NEXT_PUBLIC_BRAND_TAGLINE_EN || 'Smart Office, Simple & Efficient',
  taglineZh: process.env.NEXT_PUBLIC_BRAND_TAGLINE_ZH || '智能办公，简约高效',
  logoPath: process.env.NEXT_PUBLIC_LOGO_PATH || '/FF-Logomark-Black-4x.png',
  sampleEmailDomain: process.env.NEXT_PUBLIC_SAMPLE_EMAIL_DOMAIN || 'ff.com',
} as const;
